var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDarkpurpleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    fillRule: "evenodd",
    d: "M15.111 6.667L10 11.329 4.889 6.667 3.333 8.086 10 14.167 16.667 8.086z",
    transform: "matrix(0 1 1 0 0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDarkpurpleRight);
export default __webpack_public_path__ + "static/media/ic-arrow-darkpurple-right.591e374e60a19cbb492ac4f657063558.svg";
export { ForwardRef as ReactComponent };